import * as SDK from '@replai-platform/sdk';
import styled from 'styled-components';
import { CellData, GeneratedColumn, RequiredGeneratorParams } from '../common';
import { TypographyClean } from '../../../utils/styles';

// Kept on one line with equal-width digits, so dates line up down the column and never wrap or clip
const CreatedAt = styled(TypographyClean)`
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
`;

export type CreatedAtAccessorType = {
  createdAt?: Date;
};

const CreatedAtCellDecorator: React.FC<{
  cellData: CreatedAtAccessorType;
}> = ({ cellData }) => {
  if (!cellData) {
    return null;
  }

  return <CreatedAt>{cellData?.createdAt?.toLocaleDateString() ?? SDK.messages.NOT_AVAILABLE}</CreatedAt>;
};

function getCreatedAtColumn<T extends object = CreatedAtAccessorType>({
  columnId,
  accessor,
}: RequiredGeneratorParams<T, CreatedAtAccessorType>): GeneratedColumn<T> {
  return {
    id: columnId,
    accessor,
    Cell: (data: CellData<T, CreatedAtAccessorType>) => <CreatedAtCellDecorator cellData={data?.cell?.value} />,
  };
}

export default getCreatedAtColumn;
